import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Input, NotificationContainer, Icon, TabControl, TabItem, Dialog, Checkbox, Button} from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";
import IFormComponent from "../../models/shared/FormComponent";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import IReportTemplateFormData from "../../models/reportTemplate/ReportTemplateFormData";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import AbbTableComponent from "../shared/AbbTableComponent";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import { Translation } from "react-i18next";

// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

interface IState {
    ReportTemplateFormData: IReportTemplateFormData;
    showModalPopup: boolean; 
    list: IPropertyViewData[];
    selectedHeader: any[],
    selectedLabel: any[],
    checked: any,
    headerCount: number;
    labelsCount: number
  }

class CreateReport extends React.Component<PropsType, IState> implements IFormComponent {
  _mount: boolean;
  _columns: IColumnHeaderData[];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IReportTemplateFormData;

    this.state = {
        ReportTemplateFormData: pushStateData,
        showModalPopup: false,
        list: [],
        selectedHeader: [],
        selectedLabel: [],
        checked: false,
        headerCount: 0,
        labelsCount: 0
    };
    this._mount = false;
    this._columns = [
        {
            dataField: "property.name",
            text: "PROPERTY",
        },
        {
          dataField: "target",
          text: "TARGET",
          editable: false,
          headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'left' };
          }         
        },
        {
            dataField: "sigma",
            text: "SIGMA",
            editable: false,
            headerStyle: (colum, colIndex) => {
              return { width: '10%', textAlign: 'left' };
          }           
        },
          {
            dataField: "minValue",
            text: "MIN VALUE",
            editable: false,
            headerStyle: (colum, colIndex) => {
              return { width: '10%', textAlign: 'left' };
          }
        },
          {
          dataField: "maxValue",
          text: "MAX VALUE",
          editable: false,
          headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'left' };
          }
        },
          {
          dataField: "alarmLow1",
          text: "ALARM LOW 1",
          editable: false,
          headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'left' };
          }         
        },
          {
            dataField: "alarmHigh1",
            text: "ALARM HIGH 1",
            editable: false,
            headerStyle: (colum, colIndex) => {
              return { width: '10%', textAlign: 'left' };
          }           
        },
         
         
      ]
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    navigationHeaderActions.updateHeader({
        name: CONSTANTS.MODULE_REPORT_TEMPLATE,
        action: this.state.ReportTemplateFormData.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
        icon: this.state.ReportTemplateFormData.isEditMode ? ICONCONSTANTS.ABB_EDIT : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.REPORT_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {}
      }).then();

   }

   private preview = () => {
    this.setState({ showModalPopup: true })
  }

  private setName = (value: string) => {
    this.setState({
        ReportTemplateFormData:{
            ...this.state.ReportTemplateFormData,
            name: value 
         }
        },this.validate);
  }

  private setDescription = (value: string) => {
    this.setState({
         ReportTemplateFormData:{
            ...this.state.ReportTemplateFormData,
        description: value 
         }
    });
  }

  validate(): void {
    if (this.state.ReportTemplateFormData.name && this.state.ReportTemplateFormData.name.trim()) {
        submitHeaderActions.update({
          moduleName: CONSTANTS.MODULE_REPORT_TEMPLATE,
          isSubmitDisabled: false
        }).then();
      } else {
        submitHeaderActions.update({
          moduleName: CONSTANTS.MODULE_REPORT_TEMPLATE,
          isSubmitDisabled: true
        }).then();
      }
  }

  public onSaveClick = () => {
    
  };

  public onCreateClick = () => {

  };

  private onHeaderClick = (data: any) => {
    if(this.state.selectedHeader.includes(data.id)) {
      const index = this.state.selectedHeader.findIndex(d => d === data.id);
      this.state.selectedHeader.splice(index, 1);
      
      this.setState({
          checked: false,
          headerCount: this.state.selectedHeader.length
      })
    }
    else {
        this.state.selectedHeader.push(data.id);
        this.setState({
            checked: true,
            headerCount: this.state.selectedHeader.length
        })
    }
}

private onLabelClick = (data: any) => {
    if(this.state.selectedLabel.includes(data.id)) {
      const index = this.state.selectedLabel.findIndex(d => d === data.id);
      this.state.selectedLabel.splice(index, 1);
      this.setState({
          checked: false,
          labelsCount: this.state.selectedLabel.length
      })
    }
    else {
        this.state.selectedLabel.push(data.id);
        this.setState({
            checked: true,
            labelsCount: this.state.selectedLabel.length
        })
    }
}


  public render() {

    const Header = [{ id: 1 , name: 'Title' }, { id: 2 , name: 'Date&Time' }];
    const Labels = [{ id: 1 , name: 'Sample Name' }, {id: 2 , name: 'Station Name' }, 
    {id:3, name: 'Application Name' },{id: 4 ,  name: 'Grade Name' }, {id: 5 ,  name: 'Set No' },
     {id:6 ,  name: 'Oparator' }, { id: 7 ,name: 'Date' }];

    return (
      <Translation>
                {
                    t =>
      <div className="page-scroll">
        <div className="layout-container">
          <SubmitHeader
            name="Report Template"
            isEdit={this.state.ReportTemplateFormData.isEditMode}
            onSaveClick={this.onSaveClick}
            onCreateClick={this.onCreateClick}
          />
          <div className="row mt-4">
            <div className="col-md-12 no-padding">
              <div className="box-1">
                <div className="box-circle">
                  <p className="box-circle-text"> 1 </p>
                </div>
                <div className="ml-4">
                <p className="title">{t(CONSTANTS.MODULE_REPORT_TEMPLATE + CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}</p>
                </div>
                <hr className="hr-line" />

                <div className="row mt-3 col-md-6">
                  <div className="col-sm col-md">
                    <Input
                      dataType="text"
                      placeholder="Name"
                      label="Name"
                      required={true}
                      className="mt-2 w-50"
                       value={this.state.ReportTemplateFormData.name}
                       onValueChange={this.setName}
                    />
                  </div>
                </div>
                <div className="row mt-3 col-md-6">
                  <div className="col-sm col-md">
                    <Input
                      dataType="textarea"
                      label="Description"
                      placeholder="Description"
                      value={this.state.ReportTemplateFormData.description}
                      onValueChange={this.setDescription}
                      inputAttributes={{ rows: "4" }}
                      className="mt-2 h-25"
                      resizable={false}
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>


        <div className="row mt-3">
             <div className="col-md-12 no-padding">
              <div className="box-1"  style={{height: "auto"}}>
                <div className="box-circle">
                  <p className="box-circle-text"> 2 </p>
                </div>
                <div className="ml-4">
                  <p className="title">Template Overview
                   <span className="float-right ">
                     <Button text="Preview"
                             icon="abb/view"
                             type="discreet-blue"
                             onClick={this.preview} />
                    </span>
                  </p>
                </div>
                <hr className="hr-line " />

                <div className="mt-2 tab-area">
                  <div>
                    <TabControl type="primary" activeTab={0}>
                        <TabItem key={1} title="Report" >
                            <div className="border pb-4">
                            <div className="ml-3 mt-3 font-weight-bold"><p>Page Header
                                <span >{this.state.headerCount > 0 ? '('+ this.state.headerCount +')': ''}
                                </span></p>
                            </div>
                            <hr className="hr-line ml-3 mt-3 mr-3" />
                            <div >
                                {Header.map((i) =>
                                    <div className="border  ml-3 mt-2 p-2" style={{ width: "20%",borderRadius:"5px" }}>
                                        <Checkbox
                                            sizeClass="small"
                                            value={this.state.selectedHeader.some(d => d === i.id)}
                                            label={i.name}
                                            data={i}
                                            onChange={this.onHeaderClick}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="ml-3 mt-3 font-weight-bold"><p>Report Labels
                              <span >{this.state.labelsCount > 0 ? '('+ this.state.labelsCount +')': ''}
                              </span></p></div>
                            <hr className="hr-line ml-3 mt-3 mr-3" />
                            <div className="row mt-4">
                                {Labels.map((i) =>
                                    <div className="border float-left  mt-2 ml-4 p-1" style={{ width: "20%",borderRadius:"5px"  }}>
                                        <Checkbox
                                            sizeClass="small"
                                            value={this.state.selectedLabel.some(d => d === i.id)}
                                            label={i.name}
                                            data={i}
                                            onChange={this.onLabelClick}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        </TabItem>
                    </TabControl>

                  </div>
                </div>
                
                </div>
            </div>
        </div>
        <Dialog isOpen={this.state.showModalPopup}
            // tslint:disable-next-line: jsx-no-lambda
            onClose={() => this.setState({ showModalPopup: false })}
            showCloseButton={true}
            containerClassName = "report-dialog"
            closeOnEscape={false}
            closeOnLostFocus={false}
            dimBackground={true}
            title={'Report'}
            standardButtonsOnTop={[
              { icon: "abb/close", type: 'normal', handler: dlg => dlg.close() },
            ]}>
            <div>
            <div className="row mt-2 ml-1">
                    <div className="col-md-3">
                      <span className="summary-label">
                       {" Sample Name:"}
                      </span>
                      <span className="summary-value ml-2">
                        {"value"}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="summary-label">
                        {"Station Name:"}
                      </span>
                      <span className="summary-value ml-2">
                        {"value"}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="summary-label">
                        {"Application Name:"}
                      </span>
                      <span className="summary-value ml-2">
                        {"value"}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="summary-label">
                        {"Operator:"}
                      </span>
                      <span className="summary-value ml-2">
                        {"value"}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span className="summary-label">
                      {" Date:"}
                      </span>
                      <span className="summary-value ml-2">
                        {"14/5/2020"}
                      </span>
                    </div>
            </div>
            <div className="pb-4">
            <AbbTableComponent
            authKey={CONSTANTS.AUTHKEY_PROPERTY}
                columns={this._columns}
                list={this.state.list}
                select={false}
                 isFixedColumn={false}
                 isEditable={false}
              />
            </div>
            </div>
          </Dialog>
                
          <NotificationContainer
            actionHandler={{ remove: () => { } }}
            className="notification"
          />
        </div>
      </div>
  }
  </Translation>
    );
  }
}

export default withRouter(CreateReport);
